import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useHistory } from 'react-router-dom';

import { useSendMail } from 'mutation/mail';
import SendButton from 'containers/Mail/FormFields/SendButton';
import { EMAIL_SERVICES } from '../../../constants/common';

const SubmitForm = ({ isCsvValid, totalRows }) => {
  const { reset, watch } = useFormContext();
  const history = useHistory();

  const { isLoading, mutate } = useSendMail({ onSuccess: reset, history });

  const hasCSVFile = !!watch('csvFiles')?.length;
  const totalRecipients = watch('recipients')?.length || 0;
  const hasRecipients = !!totalRecipients;
  const forceChoose = watch('force_choose');
  const disableSchedule = hasRecipients && forceChoose === 'Gmail accounts';

  const sendNonCSVEmail = (values, isScheduling) => {
    const payload = {
      ...getReceiversAndReplacements(values.recipients),
      template_id: values.templateId,
      project_id: values.projectId,
      force_choose: values.force_choose,
      isMicrosoft: values.isMicrosoft,
      scheduled_time: values.scheduledTime || undefined,
      allow_duplicates: values.allow_duplicates,
      disable_throttling: values.disable_throttling,
      disableOpenTracking: values.disable_open_tracking,
      disableClickTracking: values.disable_click_tracking,
    };

    if (
      values.force_choose === EMAIL_SERVICES.GMAIL ||
      values.force_choose === EMAIL_SERVICES.MICROSOFT
    ) {
      payload.authorizedAccountId = values.authorizedAccountId;
    } else {
      payload.sender = {
        name: values.senderName,
        email: values.senderEmail,
      };
    }

    mutate([payload, 'regular', true, isScheduling]);
  };

  const sendCSVEmail = (values, isScheduling) => {
    const { force_choose, isMultiMode } = values;
    const payload = {
      project_id: values.projectId,
      isMultiCSV: isMultiMode,
      isMicrosoft: values.isMicrosoft,
      force_choose: force_choose,
      scheduled_time: values.scheduledTime || undefined,
      allow_duplicates: values.allow_duplicates,
      disable_throttling: values.disable_throttling,
      disableOpenTracking: values.disable_open_tracking,
      disableClickTracking: values.disable_click_tracking,
    };

    if (!isMultiMode) {
      payload.template_id = values.templateId;
      if (
        [EMAIL_SERVICES.GMAIL, EMAIL_SERVICES.MICROSOFT].includes(force_choose)
      ) {
        payload.authorizedAccountId = values.authorizedAccountId;
      } else {
        payload.sender = {
          name: values.senderName,
          email: values.senderEmail,
        };
      }
    }

    const formData = new FormData();
    formData.append('csv_file', values.csvFiles[0]);
    formData.append('payload', JSON.stringify(payload));

    mutate([formData, 'csv', true, isScheduling]);
  };

  const doSending = (values, isScheduling) => {
    if (values.csvFiles?.length) return sendCSVEmail(values, isScheduling);
    return sendNonCSVEmail(values, isScheduling);
  };

  return (
    <SendButton
      disableSchedule={disableSchedule}
      disabled={
        isLoading ||
        (!hasCSVFile && !hasRecipients) ||
        (hasCSVFile && !isCsvValid)
      }
      isLoading={isLoading}
      totalRows={hasCSVFile ? totalRows : totalRecipients}
      onSend={doSending}
    />
  );
};

const getReceiversAndReplacements = recipients => {
  const receivers = [];
  const replacements = [];
  recipients.map(v => {
    const { email, name, ...variables } = v.value;
    receivers.push({ email, name });
    replacements.push(variables);
  });
  return { receivers, replacements };
};

export default SubmitForm;
